module.exports = __webpack_public_path__ + "img/portugal-diabetes-mellitus-male.b264d703.png";